// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuCommonHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    margin-bottom: 14px;
}

.SideMenuCommonHeader_title{
    font-size: calc(18px * var(--fontScaler));;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuCommon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;AACpB","sourcesContent":[".SideMenuCommonHeader{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 14px;\n    margin-bottom: 14px;\n}\n\n.SideMenuCommonHeader_title{\n    font-size: calc(18px * var(--fontScaler));;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
